<template>
    <a-modal
        title="新增企业合同"
        :visible="visible"
        class="modal-initialize"
        width="508px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">
                    <a-form-item label="合同开始日期" v-bind="formItemLayout">
                        <a-date-picker
                            style="width: 100%"
                            placeholder="请选择合同开始日期"
                            v-decorator="['stime',{rules: [{ required: false, message: '请选择合同开始日期' }]} ]"
                        />
                    </a-form-item>

                    <a-form-item label="合同结束日期" v-bind="formItemLayout">
                        <a-date-picker
                            style="width: 100%"
                            placeholder="请选择合同结束日期"
                            v-decorator="['etime',{rules: [{ required: false, message: '请选择合同结束日期' }]} ]"
                        />
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        eid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            dateFormat: 'YYYY-MM-DD',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {

        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        values.eid = this.eid;
                        values.stime = values.stime ? values.stime.format(this.dateFormat) : '';
                        values.etime = values.etime ? values.etime.format(this.dateFormat) : '';

                        this.http('/manage/entercontract/save/', values, (res) => {
                            this.toast({content: '新增成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
    }
}
</script>